import { ChangeDetectionStrategy, Component, EventEmitter, inject, Input, OnInit, Output } from '@angular/core';

import { Observable } from 'rxjs';

import { SvgLibraryIcon } from '@finnairoyj/fcom-ui-styles';

import { ButtonMode, ButtonSize, ButtonTheme, IconButtonTheme, IconPosition, LoaderTheme } from '@fcom/ui-components';
import { FragmentService, MediaQueryService } from '@fcom/common';
import { CmsArticle } from '@fcom/core-api/interfaces';
import { Category } from '@fcom/dapi/api/models';
import { BoundWithServices, FinnairServiceItemWithUpsell } from '@fcom/dapi/interfaces';

@Component({
  selector: 'fin-upsell-card',
  templateUrl: 'upsell-card.component.html',
  styleUrls: ['../../../../assets/helper-classes.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class UpsellCardComponent implements OnInit {
  private fragmentService = inject(FragmentService);
  private mediaQueryService = inject(MediaQueryService);

  readonly ButtonMode = ButtonMode;
  readonly ButtonSize = ButtonSize;
  readonly ButtonTheme = ButtonTheme;
  readonly IconButtonTheme = IconButtonTheme;
  readonly Category = Category;
  readonly IconPosition = IconPosition;
  readonly LoaderTheme = LoaderTheme;
  readonly SvgLibraryIcon = SvgLibraryIcon;

  isMobile$: Observable<boolean>;

  @Input()
  service: FinnairServiceItemWithUpsell;

  @Input() boundWithServices: BoundWithServices;

  @Output()
  upsellClicked: EventEmitter<Category> = new EventEmitter<Category>();

  article$: Observable<CmsArticle>;
  aviosPrice: number;

  constructor() {
    this.isMobile$ = this.mediaQueryService.isBreakpoint$('mobile');
  }

  ngOnInit(): void {
    this.article$ = this.fragmentService.getFragment(this.service.upsell.articleKey);

    const allPrices = this.service.lowestPrice
      ? Object.values(this.service.lowestPrice).flatMap((paxRecord) => Object.values(paxRecord))
      : [];
    this.aviosPrice =
      allPrices
        .filter((price) => price.points?.amount != null)
        .map((price) => Number(price.points.amount))
        .reduce<number | null>((min, amount) => (min === null || amount < min ? amount : min), null) ?? 0;
  }
}
